module.exports = __webpack_public_path__ + "img/pic-placeholder-copy-15.0dba0388.svg";